import React from "react";
import Layout from "../../components/Layout";

const Developers = () => {
    return (
        <Layout>
            <section className="page-hero">
                <div className="container">
                    <div className="eyebrow"><span className="dot"></span> Developers</div>
                    <h1>Integration options for payment teams</h1>
                    <p>Connect by API, drop in a widget, or launch white-label EverWallet.</p>
                    <p>
                        <a className="btn btn-primary" href="https://developer.everest.org/" target="_blank" rel="noreferrer">
                            Full Documentation
                        </a>
                    </p>
                </div>
            </section>

            <section className="section section-tight">
                <div className="container">
                    <div className="compact-grid">
                        <article className="card">
                            <h3>API</h3>
                            <p>Direct endpoints to support onboarding processes, payment workflows (directly or via partners), wallet-related actions (where applicable), and status events.</p>
                            <p style={{ marginTop: "10px" }}>
                                <a
                                    className="btn btn-secondary"
                                    href="https://developer.everest.org/#everest-payments-api-v4"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    API Documentation
                                </a>
                            </p>
                        </article>
                        <article className="card">
                            <h3>Widget / iFrame</h3>
                            <p>Embedded customer onboarding and payment flows with reduced build time.</p>
                            <p style={{ marginTop: "10px" }}>
                                <a className="btn btn-secondary" href="https://developer.everest.org/#payment-widget" target="_blank" rel="noreferrer">
                                    Widget / iFrame Documentation
                                </a>
                            </p>
                        </article>
                        <article className="card">
                            <h3>White-label EverWallet</h3>
                            <p>Branded front end with Everest providing wallet infrastructure and operating stack (where licensed and applicable).</p>
                        </article>
                        <article className="card">
                            <h3>Webhooks and ops</h3>
                            <p>Status updates for processing events, wallet-related actions (where applicable), and operational event tracking and handling support.</p>
                        </article>
                    </div>
                </div>
            </section>

            <section className="section">
                <div className="container">
                    <p className="page-disclaimer">
                        Crypto-asset services involve significant risk, including market volatility, liquidity risk, and the potential loss of value.
                    </p>
                </div>
            </section>
        </Layout>
    );
};

export default Developers;
